import React, { useContext } from 'react';

import { FormGenerateGccCpcDoc } from '../context/FormGenerateGccCpcDoc';
import DOCGeneralInformation from './Doc/GeneralInformation';
import GccCpcGeneralInformation from './GccCpc/GeneralInformation';

const GeneralInformation = () => {
  const { type } = useContext(FormGenerateGccCpcDoc);
  if (type === 'doc') {
    return <DOCGeneralInformation />;
  }
  return <GccCpcGeneralInformation />;
};

export default GeneralInformation;
